import * as Yup from "yup";

const entrySchema = Yup.object({
  description: Yup.string().required("Description is required"),
  category: Yup.object({
    uuid: Yup.string().required("Category is required"),
  })
    .nullable()
    .required("Category is required"),
  amount: Yup.number().required("Amount is required"),
});

export const reviewValidationSchema = Yup.object({
  journalEntries: Yup.array().of(
    Yup.object({
      journal_items: Yup.array().of(entrySchema),
      manual_entries: Yup.array().of(entrySchema),
    })
  ),
});
